import { ContactTranslations } from "./types";

export const enTranslations: ContactTranslations = {
    title: "See Clinical Metrics in Action",
    description: "Schedule your personalised demo, or get in touch with our team using the form below",
    form: {
        name: "Name",
        email: "Email",
        helpMessage: "How can we help you?",
        charLimit: "Max 500 characters",
        submit: "Send",
        thankYou: "Thanks! We'll be in touch soon."
    }
};
